module.exports = __webpack_public_path__ + "img/map-1.728794f9.jpg";